import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type Cell = {
  country: string
  itemGroup: string
  waves: string[]
  subGroup?: boolean
}

interface SubscriptionState {
  value: Cell[] | null
}

export const initialState: SubscriptionState = { value: null }

const subscriptionSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setSubscription(state, action: PayloadAction<Cell[]>) {
      state.value = action.payload
    },
  },
})

export const { setSubscription } = subscriptionSlice.actions
export default subscriptionSlice.reducer
